'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MONEY = 'Money';
var WASTAGE = 'Wastage';
var TIME = 'Time';
var TRANSPORT = 'Transport';
var TAKE_KIDS_SHOPPING = 'I have to take kids shopping';

var Module4App3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module3,
    app: state.moduleData.data.module4.app3,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App3, _Component);

  function Module4App3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App3.__proto__ || (0, _getPrototypeOf2.default)(Module4App3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 3,
      appId: 8,
      module: 'Module 3',
      title: 'Barriers of maintaining stock',
      isCompleted: _this.props.app.isCompleted || false,
      difficultToStock: _this.props.app.difficultToStock || '' // is there anything that you find makes it difficult to keep a variety of fruit
      // and vegetables in your home?
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 4, 3, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module4App3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'h5',
                null,
                'We know that there are many factors that make it difficult to keep stocked up on fruit and vegetables. Is there anything that you find makes it difficult to keep a variety of fruit and vegetables in your home?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'difficultToStock') },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'difficultToStock', value: MONEY, checked: this.state.difficultToStock === MONEY },
                  MONEY
                ),
                this.state.difficultToStock === MONEY && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Fruit and vegetables can be expensive. Some suggestions for reducing the cost include:'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Buying frozen and canned products (cheaper and last longer)'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Buying fruit and vegies that are in season'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'difficultToStock', value: WASTAGE, checked: this.state.difficultToStock === WASTAGE },
                  WASTAGE
                ),
                this.state.difficultToStock === WASTAGE && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Wastage can be a problem with fruit and vegetables'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'A couple of things that can help with this are:'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Buying fruit and veg more regularly and in smaller quantities'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Buying a mixture of ripe and nearly ripe fruit and vegies'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Buying frozen and canned fruit and vegies (they keep for much longer)'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'You can cook vegies and freeze them (eg. roast pumpkin, cauliflower, as well as recipes that contain vegies eg. frittatas, soups, stir-fries, etc. for up to 3 months)'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'difficultToStock', value: TIME, checked: this.state.difficultToStock === TIME },
                  TIME
                ),
                this.state.difficultToStock === TIME && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'This is quite common'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Some things you could try to give yourself more time are planning your weekly meals (which we\'ve already talked about)'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Writing a shopping list so you know exactly what you need. Plan to purchase at least 4 different vegies and 3 different fruits a week'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'difficultToStock', value: TRANSPORT, checked: this.state.difficultToStock === TRANSPORT },
                  TRANSPORT
                ),
                this.state.difficultToStock === TRANSPORT && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'If you don\'t have a car (vehicle) buying fruit and vegtables can be hard. You could try buying canned or frozen vegetables as you\'ll have more time between each shop'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Or you could look into home delivery options'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'difficultToStock', value: TAKE_KIDS_SHOPPING, checked: this.state.difficultToStock === TAKE_KIDS_SHOPPING },
                  TAKE_KIDS_SHOPPING
                )
              ),
              this.state.difficultToStock === TAKE_KIDS_SHOPPING && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'This can be really challenging for parents. In this module, we\'ll provide a fact sheet for \'Shopping with children\' which might give you some tips about making shopping easier.'
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          ),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module4App3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func,
  profile: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module4App3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App3.js
// module id = 1208
// module chunks = 0